<template>
  <div v-if="items" :class="$style.tree">
    <div v-for="(item, index) in items" :key="index" :class="$style['tree-item']">
      <div :class="$style.collapsable">
        <v-icon :id="`icon-${index}`" :class="$style.icon" @click="collapse(index)"
          >mdi-chevron-down</v-icon
        >
        <h4 v-if="item.name" :class="$style.headline" @click="collapse(index)">
          {{ item.title }}
        </h4>
      </div>
      <ul :ref="`list-${index}`" :class="$style['tree-group']">
        <TreeViewItem
          v-for="child in item.children"
          :key="child.id"
          :item="child"
          :color="checkboxColor"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_GETTER from '@/js/components/Forms/ComplaintForm/_store-module/getter-types.js'

import TreeViewItem from './TreeViewItem.vue'

export default {
  name: 'TreeView',
  components: {
    TreeViewItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    checkboxColor: {
      type: String,
      default: '#59cbe8',
    },
  },
  computed: {
    ...mapGetters(FORM_CONSTANTS.STORE_ID, {
      selectedItems: FORM_GETTER.CHECKBOX_SELECTIONS,
    }),
  },
  methods: {
    collapse(index) {
      // bad practice because of the virtual dom. But v-icon dont return its component to use it as a ref
      document.getElementById(`icon-${index}`).classList.toggle(this.$style['icon--open'])
      this.$refs[`list-${index}`].forEach(item => {
        item.classList.toggle(this.$style.open)
      })
    },
  },
}
</script>

<style lang="scss" module>
.tree-group {
  padding-left: 0 !important;
}

.tree {
  padding: 0.3rem;

  &-item {
    & > ul {
      display: none;
    }
  }

  .collapsable {
    position: relative;

    margin-bottom: 0.5rem;
  }

  .icon {
    position: absolute;
    top: 50%;
    left: -1.7rem;

    transform: translateY(-50%);

    &--open {
      top: 15%;

      transform: rotate(180deg);
    }
  }

  .open {
    display: block;
  }

  .headline {
    margin-bottom: 0;

    cursor: pointer;
  }
}
</style>
